export default __webpack_public_path__ + "static/media/img6.06ad4c21.png";